import AdvancedReport from './AdvancedReport.vue';

const AdvancedReportRoutes = {
  path: 'advancedreport',
  name: 'sowing.harvest',
  component: AdvancedReport,
  meta: {
    prefix_permission: 'cutting_advancedreport',
  },
};

export default AdvancedReportRoutes;
